// features/licenses/transform.ts
import type { Interval, LicenseApi, LicenseRow } from "./types";

const intervalOf = (isMonthly: boolean, price: unknown): Interval =>
  isMonthly ? "aylık" : Number(price) > 0 ? "tek sefer" : "ücretsiz";



const getPlan =  (lic:LicenseApi) => {
  if(lic.LicenseProductId == (13 as any) && lic.wCompanyInfo ){
    let companyName = lic.wCompanyInfo.CompanyName ?
      lic.wCompanyInfo.CompanyName + ' ' + lic.wCompanyInfo.CompanyAddress : 'NO_W_COMPANY_INFO';
    return companyName;
  }

  return null;



}

export const makeRow = (lic: LicenseApi, isChild = false): LicenseRow => ({
  Id: lic.Id,
  key: String(lic.Id),
  licenseProductId: lic.LicenseProductId,
  service: lic.LicenseProductName,
  img: `https://api.dicebear.com/8.x/shapes/svg?seed=${encodeURIComponent(
    lic.LicenseProductId
  )}`,
  plan: getPlan(lic) as unknown as string,
  interval: intervalOf(lic.LicenseProductIsMonthly, lic.LicenseProductPrice),
  amount: Number(lic.LicenseProductPrice ?? 0),
  nextRenewal: "-",
  status: lic.IsActive ? "active" : "canceled",
  cardLast4: "—",
  isChild,
  totalAmount: Number(lic.totalAmount ?? 0),
  children:
    Array.isArray(lic.children) && lic.children.length
      ? lic.children.map((c) => makeRow(c, true))
      : undefined,
  isRequired: !!lic.LicenseProductIsRequired,
  parentLicenseId: lic.ParentLicenseId,
  isMonthly: lic.LicenseProductIsMonthly,
  invoiceInfoId: lic.InvoiceInfoId, // geçici
  wCompanyInfo: lic.wCompanyInfo, // geçici
  wUserInfo: lic.wUserInfo, // geçici
  configureUrl: lic.configure_url,
});
